import { Icon, HighlightIcon, Box } from '@dev-spendesk/grapes';
import classnames from 'classnames';
import * as Money from 'ezmoney';

import { CardPayment } from 'common/components/CardPayment/CardPayment';
import { isReversalAllocation } from 'modules/bookkeep/payables/containers/PayablePanelContainer/hooks/usePayableQuery/payable';
import { useGoToPayableDetails } from 'modules/payable/hooks/routes/useGoToPayableDetails';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import type { Payable } from '../../containers/PayablePanelContainer';

type Props = {
  className?: string;
  payable: Payable;
};

export const ReversalsAllocatedSection = ({ className, payable }: Props) => {
  const { t } = useTranslation('global');
  const goToPayableDetails = useGoToPayableDetails();

  const { allocations } = payable;
  const reversalAllocations = allocations.filter(isReversalAllocation);

  return reversalAllocations.length > 0 ? (
    <section>
      <Box
        variant="secondary"
        className={classnames('min-h-[80px] items-center', className)}
      >
        <h3 className="mb-16 text-content-primary title-l">
          {t('payables.panel.creditNoteList.title')}
        </h3>

        {reversalAllocations.map((allocation, index) => {
          const creditNoteNumber =
            allocation.reversal?.documentaryEvidence?.creditNoteNumber;

          return (
            <div
              key={allocation.reversal.id}
              className={classnames(
                'flex items-center justify-between gap-12',
                { 'mb-8': index < reversalAllocations.length - 1 },
              )}
            >
              <HighlightIcon
                name="receipt-uturn-left-top"
                size={32}
                variant="blue"
                className="shrink-0"
              />
              <CardPayment
                primarySlot={formatMonetaryValue(
                  Money.negate(allocation.amount),
                )}
                secondarySlot={creditNoteNumber ? `#${creditNoteNumber}` : ''}
                tertiarySlot={<Icon name="chevron-right" />}
                onClick={() => goToPayableDetails(allocation.reversal.id)}
              />
            </div>
          );
        })}
      </Box>
    </section>
  ) : null;
};
